/**
 * @generated SignedSource<<647c52f33e9dfa6192b20f1e285626ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandStyleImageType = "IMG" | "SVG" | "%future added value";
export type InternBrandStyleQuery$variables = {
  id: string;
};
export type InternBrandStyleQuery$data = {
  readonly brand: {
    readonly id: string;
    readonly internStyle: {
      readonly assets: ReadonlyArray<{
        readonly height: number | null;
        readonly html: string;
        readonly src: string | null;
        readonly type: InternBrandStyleImageType;
        readonly width: number | null;
      }>;
      readonly buttons: ReadonlyArray<{
        readonly backgroundColor: string;
        readonly borderColor: string;
        readonly borderRadius: string;
        readonly borderStyle: string;
        readonly borderWidth: string;
        readonly color: string;
        readonly fontFamily: string;
        readonly fontSize: string;
        readonly fontWeight: string;
        readonly padding: string;
        readonly textAlign: string;
        readonly textTransform: string;
      }>;
      readonly footerColorPalette: {
        readonly accentBackground: string;
        readonly accentForeground: string;
        readonly background: string;
        readonly foreground: string;
      };
      readonly headerColorPalette: {
        readonly accentBackground: string;
        readonly accentForeground: string;
        readonly background: string;
        readonly foreground: string;
      };
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"InternBrandScrapeAndSaveButton_brand" | "InternBrandStyleComponentMapping_brand" | "InternBrandStyleFavicon_brand" | "InternBrandStyleLogo_brand" | "InternBrandStylePalette_brand" | "InternBrandStyleTypography_brand">;
  };
};
export type InternBrandStyleQuery = {
  response: InternBrandStyleQuery$data;
  variables: InternBrandStyleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "src",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "html",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "InternBrandStyleImage",
  "kind": "LinkedField",
  "name": "assets",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borderColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borderRadius",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borderWidth",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontWeight",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "InternBrandStyleButton",
  "kind": "LinkedField",
  "name": "buttons",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "borderStyle",
      "storageKey": null
    },
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "padding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamily",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontSize",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textTransform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textAlign",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "background",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "foreground",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accentBackground",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accentForeground",
  "storageKey": null
},
v15 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "InternBrandStyleColorPalette",
  "kind": "LinkedField",
  "name": "headerColorPalette",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "InternBrandStyleColorPalette",
  "kind": "LinkedField",
  "name": "footerColorPalette",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outline",
  "storageKey": null
},
v19 = [
  (v11/*: any*/),
  (v12/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fontFace",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandStyleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandStylePalette_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandStyleLogo_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandStyleTypography_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandStyleComponentMapping_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandScrapeAndSaveButton_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternBrandStyleFavicon_brand"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InternBrandStyle",
            "kind": "LinkedField",
            "name": "internStyle",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandStyleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InternBrandStyle",
            "kind": "LinkedField",
            "name": "internStyle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyleColorPalette",
                "kind": "LinkedField",
                "name": "colorPalettes",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adPriority",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailPriority",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandComponentColorsSuggestions",
                    "kind": "LinkedField",
                    "name": "componentColors",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandButtonColorsSuggestion",
                        "kind": "LinkedField",
                        "name": "button",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandShortcutsColorsSuggestion",
                        "kind": "LinkedField",
                        "name": "shortcuts",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "container",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandBadgeColorsSuggestion",
                        "kind": "LinkedField",
                        "name": "badge",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandNavBarColorsSuggestion",
                        "kind": "LinkedField",
                        "name": "navBar",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandBackgroundColorsSuggestion",
                        "kind": "LinkedField",
                        "name": "backgrounds",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "background1",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "background2",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandOnboardingColorsSuggestion",
                        "kind": "LinkedField",
                        "name": "onboarding",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyleBasicColorPalette",
                "kind": "LinkedField",
                "name": "primaryButton",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyleBasicColorPalette",
                "kind": "LinkedField",
                "name": "navbar",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyleSuggestedButtonStyle",
                "kind": "LinkedField",
                "name": "suggestedButtonStyle",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textStyle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyleImage",
                "kind": "LinkedField",
                "name": "logos",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fonts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternFontFamilyInfo",
                "kind": "LinkedField",
                "name": "fontFaces",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternFontWeightInfo",
                    "kind": "LinkedField",
                    "name": "bold",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternFontWeightInfo",
                    "kind": "LinkedField",
                    "name": "regular",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternBrandStyleComponentMapping",
                "kind": "LinkedField",
                "name": "componentMappings",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "selector",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "style",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "favicon",
                "storageKey": null
              },
              (v5/*: any*/),
              (v10/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryPaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent1PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent2PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accent3PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "background1PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "background2PaletteLight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildThemeType",
                "kind": "LinkedField",
                "name": "buildTheme",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryButtonBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryButtonForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryButtonOutline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPillBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryPillForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondaryPillOutline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pillContainerBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "badgeBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "badgeForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navigationBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navigationForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingBackground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingForeground",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonBorderThickness",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonCornerRadius",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buttonTextStyle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandAppConfigBuildThemeFontType",
                    "kind": "LinkedField",
                    "name": "fonts",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HTMLCustomAttribute",
                "kind": "LinkedField",
                "name": "htmlCustomAttributes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "querySelector",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attributeKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attributeValue",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appLaunchDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3aba3c9ab42950e15f257faaaa7a45cd",
    "id": null,
    "metadata": {},
    "name": "InternBrandStyleQuery",
    "operationKind": "query",
    "text": "query InternBrandStyleQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    id\n    ...InternBrandStylePalette_brand\n    ...InternBrandStyleLogo_brand\n    ...InternBrandStyleTypography_brand\n    ...InternBrandStyleComponentMapping_brand\n    ...InternBrandScrapeAndSaveButton_brand\n    ...InternBrandStyleFavicon_brand\n    internStyle {\n      assets {\n        type\n        src\n        html\n        width\n        height\n      }\n      buttons {\n        backgroundColor\n        borderColor\n        borderRadius\n        borderStyle\n        borderWidth\n        color\n        padding\n        fontFamily\n        fontSize\n        fontWeight\n        textTransform\n        textAlign\n      }\n      headerColorPalette {\n        background\n        foreground\n        accentBackground\n        accentForeground\n      }\n      footerColorPalette {\n        background\n        foreground\n        accentBackground\n        accentForeground\n      }\n    }\n  }\n}\n\nfragment InternBrandScrapeAndSaveButton_brand on BrandType {\n  id\n  appConfig {\n    id\n    appState\n    appLaunchDate\n  }\n}\n\nfragment InternBrandStyleComponentMapping_brand on BrandType {\n  id\n  internStyle {\n    componentMappings {\n      selector\n      style\n    }\n  }\n  appConfig {\n    id\n    htmlCustomAttributes {\n      querySelector\n      attributeKey\n      attributeValue\n    }\n  }\n}\n\nfragment InternBrandStyleFavicon_brand on BrandType {\n  id\n  internStyle {\n    favicon\n  }\n}\n\nfragment InternBrandStyleLogo_brand on BrandType {\n  id\n  internStyle {\n    logos {\n      type\n      src\n      html\n      width\n      height\n    }\n  }\n  appConfig {\n    id\n    buildTheme {\n      id\n      logoUrl\n    }\n  }\n}\n\nfragment InternBrandStylePalette_brand on BrandType {\n  id\n  internStyle {\n    colorPalettes {\n      background\n      foreground\n      accentBackground\n      accentForeground\n      adPriority\n      emailPriority\n      componentColors {\n        button {\n          background\n          foreground\n          outline\n        }\n        shortcuts {\n          background\n          foreground\n          outline\n          container\n        }\n        badge {\n          background\n          foreground\n        }\n        navBar {\n          background\n          foreground\n        }\n        backgrounds {\n          background1\n          background2\n        }\n        onboarding {\n          background\n          foreground\n        }\n      }\n    }\n    primaryButton {\n      background\n      foreground\n      borderColor\n    }\n    navbar {\n      background\n      foreground\n    }\n    suggestedButtonStyle {\n      borderRadius\n      borderWidth\n      textStyle\n    }\n  }\n  appConfig {\n    id\n    primaryPaletteLight\n    accent1PaletteLight\n    accent2PaletteLight\n    accent3PaletteLight\n    background1PaletteLight\n    background2PaletteLight\n    buildTheme {\n      id\n      primaryButtonBackground\n      primaryButtonForeground\n      secondaryButtonOutline\n      primaryPillBackground\n      primaryPillForeground\n      secondaryPillOutline\n      pillContainerBackground\n      badgeBackground\n      badgeForeground\n      navigationBackground\n      navigationForeground\n      onboardingBackground\n      onboardingForeground\n      buttonBorderThickness\n      buttonCornerRadius\n      buttonTextStyle\n    }\n  }\n}\n\nfragment InternBrandStyleTypography_brand on BrandType {\n  id\n  internStyle {\n    fonts\n    fontFaces {\n      name\n      bold {\n        url\n        fontWeight\n        fontFace\n      }\n      regular {\n        url\n        fontWeight\n        fontFace\n      }\n    }\n  }\n  appConfig {\n    id\n    buildTheme {\n      id\n      fonts {\n        name\n        type\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b369dcba12182da5bfdedb2fe724a4c";

export default node;
